module.exports = __webpack_public_path__ + "img/image.26163df9.jpg";